import { useEffect, useState } from 'react';
import { Form, Input, Button, message, Select } from "antd";
import { useNavigate, useParams } from 'react-router-dom';
import { Country, CountryService } from "../../services/Country";
import { getCurrentUser, User, USER_ROLES, UserService } from '../../services/User';

function UserEdit() {

    const navigate = useNavigate();
    const [countries, setCountries] = useState<Country[]>([]);
    const [form] = Form.useForm();
    const params = useParams();
    const [user, setUser] = useState<User>();
    const [initValues, setInitValues] = useState({})
    const currentUser = getCurrentUser();

    useEffect( () => {
        const getCountries = async () => {
            const {data} = await CountryService.getAll()
            setCountries(data)
        }
        getCountries();
        
    }, [])



    useEffect(() => {
        if (params.id) {
            getUser(params.id)
        } else {
            setUser(undefined);

        }

    }, [params.id])

    useEffect(() => {
        form.resetFields()
    }, [initValues])

    const getUser = async (_id: string) => {
        const { data } = await UserService.getById(_id);
        setUser(data.user);
        setInitValues(data.user)
    }


    const save = async (values: any) => {
        try{
            values._id = user?._id;
            await UserService.update({ ...user, ...values })
            message.success('User successfully updated!')
            navigate(`/admin/users`, { replace: true })
        } catch(error){
            console.log(error)
        }
    };


    return (
        <div className='wrapper'>
            <h1>Edit User</h1>
            <Form
                name="basic"
                form={form}
                initialValues={initValues}
                onFinish={save}
                scrollToFirstError={true}
                className='add-item'
                layout="vertical"
                style={{padding:0}}
            >
                 <Form.Item name="name" label="Name" >
                    <Input />
                </Form.Item>

                <Form.Item name="email" label="Email" >
                    <Input />
                </Form.Item>

                {currentUser.role === USER_ROLES.ADMIN && <Form.Item name="country" label="Country">
                    <Select>
                        {countries.map( country => 
                            (<Select.Option value={country._id} key={country._id}>
                                {country.name}
                            </Select.Option>)
                        )}
                    </Select>
                </Form.Item>}

                {currentUser.role === USER_ROLES.ADMIN && <Form.Item name="role" label="Role">
                    <Select>
                        <Select.Option value={USER_ROLES.ADMIN_COUNTRY} key={USER_ROLES.ADMIN_COUNTRY}>
                                Country Admin
                        </Select.Option>
                        <Select.Option value={USER_ROLES.USER} key={USER_ROLES.USER}>
                                User
                        </Select.Option>
                    </Select>
                </Form.Item>}
                
                <Form.Item>
                    <Button type="primary" htmlType="submit" className="form-submit-button">
                        SAVE
                    </Button>
                </Form.Item>
            </Form>
            
        </div>

    );
}

export default UserEdit;